module.exports = __webpack_public_path__ + "img/nav-design-fullsize.9df9a4d.jpg";